(function($)
{
    $.extend(true, orion, {
        api: {
            complaints: {}
        }
    });

    var
        api = orion.api.complaints,
        uri = '/v1-api-complaints';

    function read()
    {
        return $.ajax(uri, {
            'method': 'GET'
        });
    }

    api.read = read;
})(jQuery);
